import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { FiChevronDown } from 'react-icons/fi';
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { CheckboxSelection } from "src/component";
import { AppFeature } from "src/model";
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, FormGroup, FormGroupWithIcon, Switch } from 'src/style';
import helpers from 'src/utils/helpers';
import utility from 'src/utils/utility';
import './style.scss';

const InstitutionDetails = () => {

    const navigate = useNavigate()
    const showFee = false
    const showCbp = true
    const {API} = useContext(ApiContext)
    const {info: {selectedInstitution, institutionData}} = useContext(AppInfoContext)
    const { notifier } = useContext(VisibilityContext)

    const [institution, setInstitution] = useState<any>(null)
    const { t } = useTranslation()
    const [input, setInput] = useState({
        newCustomerOnboardingType: '', existingCustomerOnboardingType: '',
        migrationStartDateTime: undefined, migrationEndDateTime: undefined,
        ibInstitutionCode: selectedInstitution.id, alias: selectedInstitution.alias,
        usePhoneNumberAsAccountNumber: selectedInstitution?.usePhoneNumberAsAccountNumber,
        ignoreSignatureForOnboarding: selectedInstitution?.ignoreSignatureForOnboarding || false,
        institutionName: selectedInstitution.name || '', usePremiumBvn: selectedInstitution?.usePremiumBvn || false,
        hasWeb: selectedInstitution?.hasWeb , hasMobile: selectedInstitution?.hasMobile
    })

    const [buildInput, setBuildInput] = useState({
        packageName:'',
        versionNumber:'',
        versionCode:'',
        keystorePassword:'',
        keystoreKey:'',
        keystoreAlias:'',
        updatedAt:'', id:''})

    const [bankOneToken, setBankOneToken] = useState<string>("")

    const [cbpConfig, setCbpConfig] = useState({
        ibInstitutionCode: selectedInstitution.id, intlInstitutionCode: '', branchCode: '',accountOfficerCode : '',
    })
    const [defaultDate] = !!buildInput?.updatedAt ? new Date(buildInput?.updatedAt)?.toISOString().split('T') : ''
    const [showPassword, setShowPassword] = useState(false);

    const [appFeatures, setAppFeatures] = useState<Array<AppFeature>>([])
    const [allowedFeatures, setAllowedFeatures] = useState<Array<AppFeature>>([])
    const [selectedFeatureIds, setSelectedFeatureIds] = useState<Array<string>>([])


    //AAB build information

    const getBuildInfo = useCallback(async()=>{
        const response = await API.fetchAndroidBuildInfoByCodeOrDefault(selectedInstitution.id)
        if (response?.isSuccessful) {
            setBuildInput(prev=>({
                ...prev,
                ...response?.data
            }))
        }
    },[API, selectedInstitution.id])

    useEffect(() => {
       (async()=>{
        await getBuildInfo()
       })()

    }, [selectedInstitution.id])

    useEffect(() => {
        if (selectedInstitution) {
            setInstitution(selectedInstitution)
            handleFetchInstitution()
        }
    }, [selectedInstitution])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})
    const handleBuildInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setBuildInput({...buildInput, [e.target.name]: e.target.value})
    const handleCbpConfigInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setCbpConfig({...cbpConfig, [e.target.name]: e.target.value})


    const cbpConfigPayload = {
        ibInstitutionCode: selectedInstitution.id,
        branchCode: cbpConfig.branchCode,
        intlInstitutionCode: cbpConfig.intlInstitutionCode,
        accountOfficerCode: cbpConfig.accountOfficerCode,
      };

  //Institution Details
  async function handleFetchInstitution() {
    const response = await API.getInstitutionById(selectedInstitution.id, false)
    if (response) {
    //   let [migrationStartDate, migrationEndDate] = [undefined, undefined]

    //   if (response.migrationInfo.migrationStartDate) {
    //     migrationStartDate = response.migrationInfo.migrationStartDate?.split('T')[0]
    //   }
    //   if (response.migrationInfo.migrationEndDate) {
    //     migrationEndDate = response.migrationInfo.migrationEndDate?.split('T')[0]
    //   }

      setInstitution(response)
      setInput({
        ...input,
        newCustomerOnboardingType: response.newCustomerOnboardingType,
        existingCustomerOnboardingType: response.existingCustomerOnboardingType,
        // migrationStartDateTime: migrationStartDate,
        // migrationEndDateTime: migrationEndDate,
      })
      setCbpConfig({
        ...cbpConfig,
        ibInstitutionCode: response?.cbpConfig?.ibInstitutionCode,
        intlInstitutionCode: response?.cbpConfig?.intlInstitutionCode,
        branchCode: response?.cbpConfig?.branchCode,
      })
    }
  }

  async function handleSaveCBPConfig() {
    const response = API.updateCbpConfig(cbpConfigPayload)
  }

  async function handleSaveBuildInfo() {
    const { updatedAt, id, ...payload } = buildInput
    await API.saveAndroidBuildInfo(selectedInstitution.id, { ...payload, institutionName: selectedInstitution?.name })
  }

  async function handleResetBuildInfo() {
    const response = await API.removeAndroidBuildInfo(selectedInstitution.id)
    if (response?.isSuccessful) {
      const buildResponse = await API.fetchAndroidBuildInfoByCodeOrDefault(selectedInstitution.id)
      setBuildInput(prev => ({
        ...prev,
        ...buildResponse?.data
      }))
    }
  }
  //Feature Control

  async function handleFetchAppFeatures() {
    const response = await API.getApplicationFeatures()
    if (response) {
      const featuresList = []
      for (let feature of response) {
        featuresList.push(feature)
      }

      setAppFeatures(featuresList)
    }
  }

  async function handleFetchAllowedFeatures() {
    const response = await API.getAllowedInstitutionFeatures()
    if (response) {
      const featuresList = []
      for (let feature of response) {
        featuresList.push(feature)
      }

      setAllowedFeatures(featuresList)
    }
  }


  function handleSelectedFeatures(val: boolean, info: AppFeature) {
    if (val) setSelectedFeatureIds([...selectedFeatureIds, String(info.id)])
    else {
      let chosenFeaturesIds = [...selectedFeatureIds].filter((item) => item != String(info.id))
      setSelectedFeatureIds(chosenFeaturesIds)
    }
  }


  async function handleUpdate() {
    const response = await API.updateOnboardingFlowAndMigrationInfo({ ...input, existingCustomerOnboardingType: input.newCustomerOnboardingType, institutionName: input.institutionName === "" ? selectedInstitution?.name : input.institutionName})
  }

  async function updateAllowedFeatures(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
    e.preventDefault()

    const idsToString = selectedFeatureIds.join(',')

    const response = await API.updateAllowedInstitutionFeature(idsToString)
  }

  //VerifyMe Token
  const getVerifyMeToken = async() => {
    const response = await API.getVerifyMeToken()
    if (response) {
      setBankOneToken(response?.data)
    }
  }

  const updateVerifyMeToken = async () =>{
    const response = await API.updateVerifyMeToken(btoa(bankOneToken))
    if(response){
      notifier.show(response?.responseDescription, "",'success')
    }
  }

  useEffect(() => {
    handleFetchAppFeatures();
    handleFetchAllowedFeatures();
    getVerifyMeToken();
  }, [])

  useEffect(() => {
    if (allowedFeatures?.length) {
      const allowedFeatureIds = allowedFeatures.map((feature) => String(feature.id));
      setSelectedFeatureIds(allowedFeatureIds);
    }
  }, [allowedFeatures]);




    return (
        <>
            <CustomContainer 
                className='profile-container'
            >
                <CustomContainer>
                    <FlexRow justifyContent='space-between' gap='2' wrap='wrap'>
                        <FlexRow
                            justifyContent='flex-start' gap='1'
                            width='auto' sizeUnit=''
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan textSize='2' cursor='pointer' >
                                <IoIosArrowBack />
                            </AppSpan>
                            <AppText
                                textSize='3' fontWeight='600' color='#101828' cursor='pointer'
                            >
                                 {t('institutionDetails.title')}
                            </AppText>
                        </FlexRow>
                        <Button
                            width='9'
                            titleSize='1.4' fontWeight='600'
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                            onClick={handleUpdate}
                        >
                            {t('institutionDetails.buttons.update')}
                        </Button>
                    </FlexRow>

                    <CustomContainer>
                        <FlexRow
                            bgColor='#ffffff' minHeight='10.6' alignItems='flex-start'
                            radius='0.8' padding='2' justifyContent='flex-start'
                            gap='6' wrap='wrap' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                        >
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.title')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.name}</AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.alias')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.alias}</AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.phoneNumber')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.correspondencePhone}</AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.emailAddress')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.correspondenceEmail}</AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.institutionCode')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.institutionCode}</AppSpan>
                            </CustomContainer>
                            <CustomContainer width='auto' sizeUnit=''>
                                <AppText color='#58595B' fontWeight='700'>{t('institutionDetails.institutionInfo.setupDate')}</AppText>
                                <AppSpan color='#A098AE'>{institution?.setupDate && helpers.handleDate(institution?.setupDate)}</AppSpan>
                            </CustomContainer>
                        </FlexRow>
                        <CustomContainer
                            topMargin='2' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                            bgColor='#ffffff' minHeight='48.5'
                            padding='2' radius='0.8'
                        >
                            <CustomContainer>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700'
                                >
                                    {t('institutionDetails.configuration.title')}
                                </AppLabel>
                                <FlexRow
                                    topMargin='1' gap='2'
                                    justifyContent='space-between'
                                    alignItems='stretch'
                                    className='institution-config-item'
                                >
                                    <CustomContainer
                                        borderColor='#EAECF0'
                                        shadow='0px 1px 2px 0px #1018280F'
                                        padding='2.5' radius='0.8' minHeight='15.9'
                                        leftPadding='1.7' rightPadding='1.7'
                                        width='49.5' sizeUnit='%'
                                    >
                                        <AppSpan color='#434344'>{t('institutionDetails.configuration.newCustomerOnboarding')}</AppSpan>
                                        <FormGroupWithIcon bottomMargin='0' topMargin='2'>
                                            <label>{t('institutionDetails.configuration.processFlow')}</label>
                                            <div 
                                                style={{height: '4rem', backgroundColor: '#F9FAFB'}}
                                                className="input-with-icon"
                                            >
                                                <select
                                                    name='newCustomerOnboardingType'
                                                    value={input.newCustomerOnboardingType}
                                                    onChange={handleInput}
                                                    style={{height: '4rem'}}
                                                    autoComplete='off'
                                                >
                                                    <option value="">{t('institutionDetails.configuration.options.select')}</option>
                                                    <option value="NG">{t('institutionDetails.configuration.options.nigerian')}</option>
                                                    <option value="RFS">{t('institutionDetails.configuration.options.nonNigerian')}</option>
                                                </select>
                                                <FiChevronDown className="input-with-icon-tag" />
                                            </div>
                                        </FormGroupWithIcon>
                                    </CustomContainer>

                                    <CustomContainer
                                        borderColor='#EAECF0'
                                        shadow='0px 1px 2px 0px #1018280F'
                                        padding='2.5' radius='0.8' minHeight='15.9'
                                        leftPadding='1.7' rightPadding='1.7'
                                        width='49.5' sizeUnit='%'
                                    >
                                        <AppSpan color='#434344'>{t('institutionDetails.configuration.existingCustomerOnboarding')}</AppSpan>
                                        <FormGroupWithIcon bottomMargin='0' topMargin='2'>
                                            <label>{t('institutionDetails.configuration.processFlow')}</label>
                                            <div 
                                                style={{height: '4rem', backgroundColor: '#F9FAFB'}}
                                                className="input-with-icon"
                                            >
                                                <select
                                                    name='newCustomerOnboardingType'
                                                    value={input.newCustomerOnboardingType}
                                                    onChange={handleInput}
                                                    style={{height: '4rem'}}
                                                    autoComplete='off'
                                                >
                                                    <option value="">{t('institutionDetails.configuration.options.select')}</option>
                                                   <option value="NG">{t('institutionDetails.configuration.options.nigerian')}</option>
                                                    <option value="RFS">{t('institutionDetails.configuration.options.nonNigerian')}</option>
                                                </select>
                                                <FiChevronDown className="input-with-icon-tag" />
                                            </div>
                                        </FormGroupWithIcon>
                                    </CustomContainer>
                                </FlexRow>
                            </CustomContainer>

                            <FormGroupWithIcon width={"50"} topMargin='3' bottomMargin='3'>
                               <label style={{fontSize:"2rem"}}>Institution Name</label>
                                <div className="input-with-icon">
                                    <input
                                        placeholder="Enter institution name"
                                        name='institutionName'
                                        type={'text'}
                                        value={input.institutionName}
                                        onChange={handleInput}
                                        autoComplete='off'
                                        required
                                    />
                                </div>
                            </FormGroupWithIcon>

                            {/* <CustomContainer topMargin='2'> */}
                                {/* <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700'
                                >
                                   {t('institutionDetails.migration.title')}
                                </AppLabel>
                                <CustomContainer
                                    borderColor='#EAECF0' topMargin='1'
                                    shadow='0px 1px 2px 0px #1018280F'
                                    padding='2' radius='0.8' minHeight='11.6'
                                    leftPadding='1.7' rightPadding='1.7'
                                >
                                    <FlexRow
                                        gap='2'
                                        justifyContent='space-between'
                                        alignItems='stretch'
                                        className='institution-config-item'
                                    >
                                        <FormGroup
                                            bottomMargin='0' height='4'
                                            width='49.5'
                                        >
                                            <label>{t('institutionDetails.migration.startDate')}</label>
                                            <input 
                                                name='migrationStartDateTime'
                                                type='date'
                                                style={{color: input.migrationStartDateTime ? '#000000' : '#667085', backgroundColor: '#F9FAFB'}}
                                                value={input.migrationStartDateTime}
                                                onChange={handleInput}
                                                autoComplete="off"
                                            />
                                        </FormGroup>
                                        <FormGroup
                                            bottomMargin='0' height='4'
                                            width='49.5'
                                        >
                                            <label>{t('institutionDetails.migration.endDate')}</label>
                                            <input 
                                                name='migrationEndDateTime'
                                                type='date'
                                                style={{color: input.migrationEndDateTime ? '#000000' : '#667085', backgroundColor: '#F9FAFB'}}
                                                value={input.migrationEndDateTime}
                                                onChange={handleInput}
                                                autoComplete="off"
                                            />
                                        </FormGroup>
                                    </FlexRow>
                                    <FlexRow
                                        topMargin='2.5' gap="1.5"
                                        alignItems="flex-start" justifyContent="flex-start"
                                    >
                                        <AppSpan fontWeight="600" color="#344054">{t('institutionDetails.migration.completion')}</AppSpan>
                                        <Switch
                                            radius='1.17' bgColor='#E7E7E7'
                                            checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                        >
                                            <input
                                                type="checkbox"
                                                checked={institution?.migrationInfo?.migrationCompleted}
                                            />
                                            <div ></div>
                                            <span></span>
                                        </Switch>
                                    </FlexRow> */}
                                {/* </CustomContainer> */}
                            {/* </CustomContainer> */}

                            <CustomContainer topMargin='2'>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700'
                                >
                                    {t('institutionDetails.otherInfo.title')}
                                </AppLabel>
                                <FlexRow
                                    topMargin='1' gap='2'
                                    justifyContent='space-between'
                                    alignItems='stretch'
                                    className='institution-config-item'
                                >
                                    <CustomContainer
                                        borderColor='#EAECF0'
                                        shadow='0px 1px 2px 0px #1018280F'
                                        padding='2.5' radius='0.8' minHeight='15.9'
                                        leftPadding='1.7' rightPadding='1.7'
                                        sizeUnit='%'
                                    >
                                        <AppSpan color='#434344'>{t('institutionDetails.otherInfo.updateDetails')}</AppSpan>
                                        <FlexRow gap={"3"} justifyContent="space-between">

                                        <FormGroup 
                                            topMargin="1.5" bgColor='#F9FAFB'
                                        >
                                            <label>{t('institutionDetails.otherInfo.institutionAlias')}</label>
                                            <input
                                                placeholder={t('institutionDetails.otherInfo.aliasPlaceholder')}
                                                name='alias'
                                                value={input.alias}
                                                onChange={handleInput}
                                                required
                                            />
                                        </FormGroup>
                                            <FlexRow
                                                topMargin='2.5' gap="1.5"
                                                alignItems="flex-start" justifyContent="flex-start"
                                            >
                                                <AppSpan fontWeight="600" color="#344054">Use Phone number as Account number</AppSpan>
                                                <Switch
                                                    radius='1.17' bgColor='#E7E7E7'
                                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={input?.usePhoneNumberAsAccountNumber}
                                                        onChange={(e) => setInput({
                                                            ...input,
                                                            usePhoneNumberAsAccountNumber: e.target.checked
                                                        })}
                                                    />
                                                     <div ></div>
                                                    <span></span>
                                                </Switch>
                                            </FlexRow>

                                            <FlexRow
                                                topMargin='2.5' gap="1.5"
                                                alignItems="flex-start" justifyContent="flex-start"
                                            >
                                                <AppSpan fontWeight="600" color="#344054">Use Premium BVN</AppSpan>
                                                <Switch
                                                    radius='1.17' bgColor='#E7E7E7'
                                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={input?.usePremiumBvn}
                                                        onChange={(e) => setInput({
                                                            ...input,
                                                            usePremiumBvn: e.target.checked
                                                        })}
                                                    />
                                                     <div ></div>
                                                    <span></span>
                                                </Switch>
                                            </FlexRow>


                                            <FlexRow
                                                topMargin='2.5' gap="1.5"
                                                alignItems="flex-start" justifyContent="flex-start"
                                            >
                                                <AppSpan fontWeight="600" color="#344054">Ignore Signature for onboarding</AppSpan>
                                                <Switch
                                                    radius='1.17' bgColor='#E7E7E7'
                                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={input?.ignoreSignatureForOnboarding}
                                                        onChange={(e) => setInput({
                                                            ...input,
                                                            ignoreSignatureForOnboarding: e.target.checked
                                                        })}

                                                    />
                                                    <div ></div>
                                                    <span></span>
                                                </Switch>
                                            </FlexRow>
                                        </FlexRow>
                                        
                                        <FlexRow gap='2' justifyContent='center'>
                                        <FlexRow
                                                topMargin='2.5' gap="1.5"
                                                alignItems="flex-start" justifyContent="flex-start"
                                            >
                                                <AppSpan fontWeight="600" color="#344054">Has Mobile</AppSpan>
                                                <Switch
                                                    radius='1.17' bgColor='#E7E7E7'
                                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={input?.hasMobile}
                                                        onChange={(e) => setInput({
                                                            ...input,
                                                            hasMobile: e.target.checked
                                                        })}

                                                    />
                                                    <div ></div>
                                                    <span></span>
                                                </Switch>
                                            </FlexRow>

                                              <FlexRow
                                                topMargin='2.5' gap="1.5"
                                                alignItems="flex-start" justifyContent="flex-start"
                                            >
                                                <AppSpan fontWeight="600" color="#344054">Has Web</AppSpan>
                                                <Switch
                                                    radius='1.17' bgColor='#E7E7E7'
                                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={input?.hasWeb}
                                                        onChange={(e) => setInput({
                                                            ...input,
                                                            hasWeb: e.target.checked
                                                        })}

                                                    />
                                                    <div ></div>
                                                    <span></span>
                                                </Switch>
                                            </FlexRow>

                                            </FlexRow>

                                    </CustomContainer>
                                </FlexRow>
                            </CustomContainer>

                     {/* CBP Configuration */}
                         {showCbp && (
                        <CustomContainer
                            topMargin='2' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                            bgColor='#ffffff' minHeight='30.5'
                            padding='2' radius='0.8'
                        >
                            <CustomContainer topMargin='2'>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700' bottomMargin='2'
                                >
                                    {t('institutionDetails.cbpConfig.title')}
                                </AppLabel>

                                <FlexRow gap='2'>
                                    <FormGroupWithIcon>
                                        <label>{t('institutionDetails.cbpConfig.internationalInstitutionCode')}</label>
                                        <div className="input-with-icon">
                                            <input
                                                placeholder="-----"
                                                name='intlInstitutionCode'
                                                value={cbpConfig?.intlInstitutionCode}
                                                onChange={handleCbpConfigInput}
                                                autoComplete='off'
                                                required
                                                readOnly
                                            />
                                            <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                                {/* {explain(`This is the contact email`, true, '0')} */}
                                            </CustomContainer>

                                        </div>
                                    </FormGroupWithIcon>

                                    <FormGroupWithIcon>
                                        <label>{t('institutionDetails.cbpConfig.branchCode')}</label>
                                        <div className="input-with-icon">
                                            <input
                                                placeholder={t('institutionDetails.cbpConfig.branchCodePlaceholder')}
                                                name='branchCode'
                                                value={cbpConfig?.branchCode}
                                                onChange={handleCbpConfigInput}
                                                autoComplete='off'
                                                required
                                            />
                                            <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                                {/* {explain(`This is the contact email`, true, '0')} */}
                                            </CustomContainer>

                                        </div>
                                    </FormGroupWithIcon>

                                     <FormGroupWithIcon>
                                        <label>Account officer code</label>
                                        <div className="input-with-icon">
                                            <input
                                                placeholder="Enter account officer code"
                                                name='accountOfficerCode'
                                                value={cbpConfig?.accountOfficerCode}
                                                onChange={handleCbpConfigInput}
                                                autoComplete='off'
                                                required
                                            />
                                            <CustomContainer width='auto' sizeUnit='' className="input-with-icon-tag" >
                                                {/* {explain(`This is the contact email`, true, '0')} */}
                                            </CustomContainer>

                                        </div>
                                    </FormGroupWithIcon>
                                </FlexRow>

                            </CustomContainer>
                            <FlexRow justifyContent='flex-end' gap='2'>
                                <Button
                                    width='16'
                                    titleSize='1.4' fontWeight='600'
                                    height='4' radius='0.8'
                                    bottomMargin='3.5' hoverColor='#0D968F'
                                    hoverBgColor='#fff' borderColor='#0D968F'
                                    onClick={handleSaveCBPConfig}
                                >
                                    {t('institutionDetails.buttons.saveCbpConfig')}
                                </Button>
                            </FlexRow>
                        </CustomContainer>
                          )}

                        </CustomContainer>


                        <CustomContainer
                            topMargin='2' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                            bgColor='#ffffff' minHeight='48.5'
                            padding='2' radius='0.8'
                        >
                            <CustomContainer topMargin='2'>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700' bottomMargin='2'
                                >
                                    {t('institutionDetails.featureControl.title')}
                                </AppLabel>
                            </CustomContainer>

                            <CustomContainer>
                                <FlexRow
                                    justifyContent='flex-start' gap='2' wrap='wrap'
                                    className='control-box-container'
                                >
                                    {
                                        appFeatures?.map((item: AppFeature, index: number) => {
                                            return (
                                                <CheckboxSelection
                                                    key={index}
                                                    name={item.name}
                                                    customClass='feature-control-box'
                                                    output={(val: boolean) => handleSelectedFeatures(val, item)}
                                                    value={selectedFeatureIds.includes(String(item.id))}
                                                    // disabled={userRole != UserTypes.ADMIN || shouldDisableCheckbox(item)}
                                                />
                                            )
                                        })
                                    }
                                </FlexRow>
                                <CustomContainer topMargin='5'>
                                    <FlexRow justifyContent='flex-end'>
                                    <Button
                                        width='20'
                                        titleSize='1.4' fontWeight='600'
                                        height='4' radius='0.8'
                                        bottomMargin='1' hoverColor='#0D968F'
                                        hoverBgColor='#fff' borderColor='#0D968F'
                                        onClick={updateAllowedFeatures}
                                    >
                                        {t('institutionDetails.buttons.updateFeatures')}
                                    </Button>
                                    </FlexRow>
                                </CustomContainer>
                            </CustomContainer>

                        </CustomContainer>

                        <CustomContainer
                            topMargin='2' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                            bgColor='#ffffff' minHeight='35.5'
                            padding='2' radius='0.8'
                        >
                            <CustomContainer topMargin='2'>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700' bottomMargin='2'
                                >
                                    VerifyMe Token
                                </AppLabel>
                            </CustomContainer>

                            <CustomContainer>
                                <FlexRow
                                    justifyContent='flex-start' gap='2' wrap='wrap'
                                    className='control-box-container'
                                >
                                    {/*<FormGroup*/}
                                    {/*    topMargin="1.5" bgColor='#F9FAFB'*/}
                                    {/*>*/}
                                    {/*    <label>VerifyMe Token</label>*/}
                                    {/*    <input*/}
                                    {/*        placeholder="Enter verify-me token"*/}
                                    {/*        name='bankoneToken'*/}
                                    {/*        value={bankOneToken}*/}
                                    {/*        onChange={(e)=>setBankOneToken(e.target.value)}*/}
                                    {/*        required*/}
                                    {/*    />*/}
                                    {/*</FormGroup>*/}

                                    <FormGroupWithIcon width={"50"}>
                                        <label>VerifyMe Token</label>
                                        <div className="input-with-icon">
                                            <input
                                                placeholder="XXXXXXX"
                                                name='bankoneToken'
                                                type={showPassword ? 'text' : 'password'}
                                                value={bankOneToken}
                                                onChange={(e)=>setBankOneToken(e.target.value)}
                                                autoComplete='off'
                                                required
                                            />
                                            {!showPassword ?
                                                <AbsoluteContainer bottom='2' right='1'>
                                                    <AppSpan
                                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                                        onClick={() => setShowPassword(true)}
                                                    >
                                                        <BsEyeSlash fontSize='1.7rem' />
                                                    </AppSpan>
                                                </AbsoluteContainer>
                                                :
                                                <AbsoluteContainer bottom='2' right='1'>
                                                    <AppSpan
                                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                                        onClick={() => setShowPassword(false)}
                                                    >
                                                        <BsEye fontSize='1.7rem' />
                                                    </AppSpan>
                                                </AbsoluteContainer>
                                            }
                                        </div>
                                    </FormGroupWithIcon>

                                </FlexRow>
                                <CustomContainer topMargin='5'>
                                    <FlexRow justifyContent='flex-end'>
                                        <Button
                                            width='15'
                                            titleSize='1.4' fontWeight='600'
                                            height='4' radius='0.8'
                                            hoverColor='#0D968F'
                                            hoverBgColor='#fff' borderColor='#0D968F'
                                            onClick={updateVerifyMeToken}
                                        >
                                            Update Token
                                        </Button>
                                    </FlexRow>
                                </CustomContainer>
                            </CustomContainer>

                        </CustomContainer>


                        <CustomContainer
                            topMargin='2' borderColor='#EAECF0'
                            shadow='0px 1px 2px 0px #1018280F'
                            bgColor='#ffffff' minHeight='48.5'
                            padding='2' radius='0.8'
                        >
                            <CustomContainer topMargin='2'>
                                <AppLabel
                                    color='#101828' textSize='1.8'
                                    fontWeight='700' bottomMargin='2'
                                >
                                    {t('institutionDetails.buildSettings.title')}
                                </AppLabel>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.packageName')}</label>
                            <div className="input-with-icon">
                                <input
                                    placeholder="-----"
                                    name='packageName'
                                    value={buildInput.packageName}
                                    onChange={handleBuildInput}
                                    autoComplete='off'
                                    required
                                />

                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.versionNumber')}</label>
                            <div className="input-with-icon">
                                <input
                                    placeholder=""
                                    name='versionNumber'
                                    value={buildInput.versionNumber}
                                    onChange={handleBuildInput}
                                    autoComplete='off'
                                    required
                                />

                            </div>
                        </FormGroupWithIcon>
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.versionCode')}</label>
                            <div className="input-with-icon">
                                <input
                                    placeholder=""
                                    name='versionCode'
                                    value={buildInput.versionCode}
                                    onChange={handleBuildInput}
                                    autoComplete='off'
                                    required
                                />

                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                        <label>{t('institutionDetails.buildSettings.keystorePassword')}</label>
                        <div className="input-with-icon">
                            <input
                                placeholder="XXXXXXX"
                                name='keystorePassword'
                                type={showPassword ? 'text' : 'password'}
                                value={buildInput.keystorePassword}
                                onChange={handleBuildInput}
                                autoComplete='off'
                                required
                            />
                            { !showPassword ?
                                <AbsoluteContainer bottom='2' right='3'>
                                    <AppSpan
                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                        onClick={() => setShowPassword(true)}
                                    >
                                        <BsEyeSlash fontSize='1.7rem' />
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='2' right='3'>
                                    <AppSpan
                                        color='rgba(0, 0, 0, 0.5)' cursor='pointer'
                                        onClick={() => setShowPassword(false)}
                                    >
                                        <BsEye fontSize='1.7rem' />
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </div>
                    </FormGroupWithIcon>
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.keystoreKey')}</label>
                            <div className="input-with-icon">
                                <input
                                    placeholder=""
                                    name='keystoreKey'
                                    value={buildInput.keystoreKey}
                                    onChange={handleBuildInput}
                                    autoComplete='off'
                                    required
                                />

                            </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.keystoreAlias')}</label>
                            <div className="input-with-icon">
                                <input
                                    placeholder=""
                                    name='keystoreAlias'
                                    value={buildInput.keystoreAlias}
                                    onChange={handleBuildInput}
                                    autoComplete='off'
                                    required
                                    // disabled={}
                                />
                            </div>
                        </FormGroupWithIcon>
                    </FlexRow>
                    <FlexRow gap='2'>
                        <FormGroupWithIcon>
                            <label>{t('institutionDetails.buildSettings.updatedAt')}</label>
                                <div className="input-with-icon">
                                    <input
                                    name='updatedAt'
                                    type='date'
                                    max={helpers.getInputValidDate()}
                                    value={defaultDate}
                                    onChange={handleBuildInput}
                                    autoComplete="off"
                                />
                                </div>
                        </FormGroupWithIcon>
                        <FormGroupWithIcon />
                    </FlexRow>
                            </CustomContainer>
                        <FlexRow justifyContent='flex-end' gap='2'>
                            <Button
                                width='15'
                                titleSize='1.4' fontWeight='600'
                                height='4' radius='0.8' color='#344054'
                                bottomMargin='3.5' hoverColor='#0D968F'
                                bgColor='#fff' borderColor='#ccc'
                                hoverBorderColor='#0D968F'
                                onClick={handleResetBuildInfo}
                            >
                                {t('institutionDetails.buttons.resetToDefault')}
                            </Button>
                            <Button
                                width='16'
                                titleSize='1.4' fontWeight='600'
                                height='4' radius='0.8'
                                bottomMargin='3.5' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                                onClick={handleSaveBuildInfo}
                            >
                                {t('institutionDetails.buttons.saveBuildSettings')}
                            </Button>
                        </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            </CustomContainer>
        </>
    )
}

export default utility.routeData('institution-details', 'Institution Details', <InstitutionDetails/>)